import {
  Directive,
  ElementRef,
  HostBinding,
  Input,
  OnChanges,
  OnDestroy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { TargetIdService } from "src/services/target-id.service";

function transformVwTargetable(value: boolean | undefined): boolean {
  return value == null || Boolean(value);
}

@Directive({
  selector: "[vwTargetable][id]",
})
export class TargetableDirective implements OnChanges, OnDestroy {
  @Input({
    required: true,
    transform: transformVwTargetable,
  })
  vwTargetable: boolean = true;
  @HostBinding("attr.id") @Input({ required: true }) id: string | undefined;
  private subscription: Subscription | null = null;
  constructor(
    private eRef: ElementRef<Element>,
    private targetIdService: TargetIdService,
  ) {}

  get active() {
    return this.eRef.nativeElement.classList.contains("target");
  }

  set active(val: boolean) {
    if (val) this.eRef.nativeElement.classList.add("target");
    else this.eRef.nativeElement.classList.remove("target");
  }

  ngOnDestroy(): void {
    this.stopSubscriber();
  }

  private stopSubscriber() {
    if (this.subscription) {
      if (!this.subscription.closed) this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

  private startSubscriber() {
    if (this.subscription == null || this.subscription.closed) {
      this.subscription = this.targetIdService.targetId.subscribe({
        next: (id) => {
          this.active = this.id === id;
        },
      });
    }
  }

  ngOnChanges(): void {
    if (this.id == null || !this.vwTargetable) {
      this.stopSubscriber();
    } else {
      this.startSubscriber();
      this.active = this.id === this.targetIdService.targetId.value;
    }
  }
}
